export const regLicensePlateNumber = new RegExp(`^[A-Z0-9]{2,4}-[A-Z0-9]{2,4}$`);
